export const translation_2_3_A = {
  en: {},
  ko: {
    v1: {
      typography_0:
        "자, 지금부터 디스턴싱 연습을 시작해볼게요.",
      typography_0_1: "시작하기에 앞서 디스턴싱(Distancing)이 무엇이라고 생각하시나요? 이름을 보니 무슨 뜻인 것 같나요?",
      typography_0_2: "좋아요. 많은 분들이 디스턴싱을 단지 '생각을 떨어뜨리고 그로부터 빠져나오는 것'으로 이해하곤 하시는데요.",
      typography_0_3: "그렇지 않습니다. 디스턴싱은 그보다 훨씬 더 적극적인 삶의 자세예요.",
      typography_0_4: "디스턴싱은 (1) 생각과 거리를 두고, (2) 기꺼이 경험한 뒤, (3) 가치로 나아가는 삶의 태도를 말합니다.",
      typography_0_5: "마음속 사건들을 이해하고, 괴로움으로부터 자유로워져, 삶의 모든 부분을 만끽하며, 내 삶의 주인이 되어가는 과정이지요.",
      typography_0_6: "3개월 동안 배우고 익혀나갈 것이니, 차근차근 따라오시면 된답니다.",
      typography_0_7: "우선 오늘은 '분리하기'라는 아주 기초적이면서도 아주 중요한 개념부터 배워볼까 해요.",
      typography_0_8: "디스턴싱의 첫 번째 파트인 (1) 생각과 거리두기에서 필요한 기술이지요.",
      typography_0_9: "모든 기본기가 그렇듯, 이것만 잘 익혀도 디스턴싱 실력에 아주 큰 도움이 된답니다.",
      typography_0_10: "그럼 시작해볼까요?",
      typography_1: "디스턴싱의 기본은 ‘분리하기'에서 시작해요.",
      typography_2: "분리하기가 뭔지 조금 더 자세히 알아볼게요.",
      typography_3: "꾸러미로 떠오르는 생각",
      typography_4:
        "마음속의 생각을 거리두고 바라보는 것, 말로만 들으면 꽤나 간단해 보이는데요.",
      typography_5:
        "하지만 실제 우리가 마음속에서 마주하는 건 그보다 더 복잡하답니다.",
      typography_6:
        "사실 우리 마음속에서는 생각, 감정, 신체 반응, 행동 등이 복잡하게 뒤섞여 하나의 ‘꾸러미'처럼 떠올라요.",
      typography_7:
        "물론 때로는 그저 단편적인 생각들만 마음속에 떠오르는 것 같기도 해요.",
      typography_8: `"이따 밥 뭐 먹지?", "오늘 피곤하네"`,
      typography_9:
        "이런 생각들을 인식하는 데에는 큰 어려움이 없고, 그렇기 때문에 그것을 거리두고 바라보기도 더 용이하죠.",
      typography_10:
        "예를 들어, 마음속에 이런 생각이 떠올랐다고 해보죠.",
      typography_11: `"이번 프로젝트는 내가 다 망친 거야."`,
      typography_12:
        "그러면 곧바로 아주 강렬한 감정이 찾아옵니다.",
      typography_13: "죄책감, 후회, 미련, 분노, 슬픔, 자괴감.",
      typography_14: "때론 강력한 신체적인 감각이 동반되기도 해요.",
      typography_15: "두통이 찾아오고, 가슴이 답답하고, 호흡이 가빠오죠.",
      typography_16: "특정한 행동을 하고 싶은 충동도 느껴져요.",
      typography_17: "‘다 그만둘까?’, ‘퇴사하고 싶어'",
      typography_18:
        "이처럼 강렬한 감정을 마주했을 때 생각은 감정, 신체 반응, 행동과 함께 하나의 꾸러미처럼 떠오른답니다.",

      typography_18_0_1: "거리두기를 방해하는 꾸러미",
      typography_18_0_2: "꾸러미 속 생각, 감정, 신체 반응, 행동은 서로 영향을 주고 받습니다.",
      typography_18_0_3: "생각이 감정을 만들기도 하고, 감정이 생각을 만들기도 합니다.",
      typography_18_0_4: "또 어떤 신체 반응 때문에 생각이 떠오르기도 하고, 또 반대로 생각이 신체 반응을 만들어내기도 합니다.",
      typography_18_0_5: "이는 얼기설기 얽힌 실타래와 같습니다.",

      typography_19: "가장 먼저 해야 하는 일, 분리",
      typography_20:
        "따라서 꾸러미를 그대로 두고는, 생각과 거리를 두는 일은 불가능에 가깝습니다.",
      typography_21:
        "정확히 어떤 생각이 마음속에 떠오르는지 이해하기도 힘들고,",
      typography_22: "또 그것이 주는 강렬한 감정이 너무 커보이기도 하거든요.",
      typography_23:
        "따라서 우리는 이 꾸러미를 각각의 개별 요소로 분리할 필요가 있어요.",
      typography_24: "이러한 과정을 분리하기(segmentation)라고 부른답니다.",

      typography_24_0_1: "생각기록지로 분리 연습하기",
      typography_25: "방법은 간단해요.",
      typography_26: "어떤 강렬한 심리적 경험을 마주할 때,",
      typography_27: "그 내용을 일기장에 감정을 털어놓듯 무작정 옮기지 말고,",
      typography_28:
        "상황, 생각, 감정, 신체 반응, 행동을 나눠서 적어 보는 거예요.",
      typography_29:
        "이렇게 각각의 요소로 해체하여 관찰하면 각 요소를 그저 마음속에 떠오르는 하나의 ‘심리적 사건’으로 바라보기 더 쉽답니다.",
      typography_30:
        "그뿐만 아니라 앞으로 함께 초점을 맞춰볼 생각을 더 정확하게 알아차릴 수도 있을 거예요.",

      typography_30_0_1: "오늘부터 <생각기록지>라는 곳에 적어나갈 거랍니다.",
      typography_30_0_2: "하지만 많은 분들이 <생각기록지>를 일기장처럼 사용하시거나",
      typography_30_0_3: "코치 선생님에게 무언가를 얘기해주는 공간으로 사용하시곤 하는데요.",
      typography_30_0_4: "이는 <생각기록지>의 잘못된 사용법입니다.",
      typography_30_0_5: "<생각기록지>는 꾸러미를 줄줄이 쏟아내며 곱씹는 일기장도 아니고",
      typography_30_0_6: "코치 선생님에게 나의 이야기를 털어놓는 상담실도 아닙니다.",
      typography_30_0_7: "<생각기록지>는 앞으로 배워나갈 디스턴싱 기술들을 스스로 꾸준히 훈련하는 공간임을 꼭 기억해주세요.",
      typography_31:
        "자, 다음 활동에서는 분리하기를 어떻게 하는 건지 함께 알아볼게요.",
    },
  },
};
